<div class="gup-C-lazyListPicker">

    <kal-input icon="keyboard_arrow_down"
               placeholder="Rechercher..."
               [label]="label"
               [formControl]="control"
               [kalAutocomplete]="optionsList"
               [kalAutocompleteOptionTemplate]="optionTemplate"
               [kalAutocompleteLoading]="loading"
               [kalAutocompleteEmptyLabel]="emptyMessage"
               [kalScrollStrategy]="autocompleteScrollStrategy"
               kalAutocompleteHeight="30vh"
               (kalAutocompleteSelected)="pick($event)">
    </kal-input>

    <ng-template #optionTemplate let-option="option">
        <span>{{ option.label }}</span>
    </ng-template>

</div>
